const setFilter = filter => ({
  type: 'SET_FILTER',
  filter,
});

export default setFilter;
